import { render, staticRenderFns } from "./TrendCharts.vue?vue&type=template&id=2300e49f&scoped=true"
import script from "./TrendCharts.vue?vue&type=script&lang=js"
export * from "./TrendCharts.vue?vue&type=script&lang=js"
import style0 from "./TrendCharts.vue?vue&type=style&index=0&id=2300e49f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2300e49f",
  null
  
)

export default component.exports